var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "flatNav" }, [
    _c("div", { staticClass: "bg_left" }),
    _vm._v(" "),
    _c("div", { staticClass: "w" }, [
      _vm.data.meta && _vm.data.meta.des
        ? _c("div", { staticClass: "about" }, [
            _c("div", { staticClass: "title" }, [
              _vm._v(_vm._s(_vm.data.meta.title))
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "des" }, [
              _vm._v(_vm._s(_vm.data.meta.des))
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "list",
          class: _vm.data.children && _vm.data.children.length > 4 ? "warp" : ""
        },
        _vm._l(_vm.data.children, function(item, index) {
          return _c("div", { key: index, staticClass: "item" }, [
            _c("div", [
              _c("div", { staticClass: "icon" }, [
                _c("img", {
                  attrs: {
                    src: require("../../assets/images/" +
                      item.meta.icon +
                      ".png"),
                    alt: ""
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "title" }, [
                !item.open
                  ? _c(
                      "span",
                      {
                        staticStyle: { cursor: "pointer" },
                        on: {
                          click: function($event) {
                            return _vm.menusClick(item)
                          }
                        }
                      },
                      [_vm._v(_vm._s(item.meta.title))]
                    )
                  : _c("a", { attrs: { target: "_blank", href: item.open } }, [
                      _vm._v(_vm._s(item.meta.title))
                    ])
              ]),
              _vm._v(" "),
              item.meta && item.meta.des
                ? _c("div", { staticClass: "des" }, [
                    _vm._v(_vm._s(item.meta.des))
                  ])
                : _vm._e()
            ])
          ])
        }),
        0
      )
    ]),
    _vm._v(" "),
    _c("div")
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c4bbb830", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c4bbb830","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/styleMenus.vue
// module id = null
// module chunks = 